import React from 'react';

const PROCESS_STEPS = [
  {
    num: '01',
    name: 'Discovery & Automation Audit',
    desc: 'We map your existing manual workflows, analyze operational bottlenecks, and perform a free automation audit to quantify potential cost savings.',
  },
  {
    num: '02',
    name: 'System & AI Architecture',
    desc: 'We design a clean, cloud-native architecture, define database schemas, and map out secure AI/LLM integration points tailored to your business.',
  },
  {
    num: '03',
    name: 'Agile Custom Build',
    desc: 'We develop your solution in bi-weekly sprints. You get live demo access at every milestone, giving you complete visibility as your software comes to life.',
  },
  {
    num: '04',
    name: 'CI/CD & Security Deployment',
    desc: 'We containerize your applications with Docker, set up automated CI/CD pipelines, and deploy to your cloud environment (AWS, GCP, or Azure).',
  },
  {
    num: '05',
    name: 'Full Ownership & Ongoing Support',
    desc: 'We hand over 100% of the source code with comprehensive documentation, train your team, and provide continuous SLA-backed maintenance.',
  },
];

const ProcessTimeline: React.FC = () => {
  return (
    <section id="process" className="py-24 bg-white text-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <p className="text-blue-700 text-sm font-semibold uppercase tracking-widest mb-3">
            How We Work
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 mb-4">
            A Predictable 5-Step <span className="text-blue-700">Engineering Methodology</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            No scope creep, no hidden fees, no black boxes. We deliver custom software on time, on budget, and built to enterprise standards.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-5 gap-4">
          {PROCESS_STEPS.map((step, i) => (
            <div
              key={step.num}
              className="bg-gray-50 border border-gray-200 rounded-2xl p-6 relative flex flex-col justify-between hover:border-blue-300 hover:shadow-lg transition-all"
            >
              <div>
                <span className="text-3xl font-black text-blue-600/30 font-mono block mb-3">{step.num}</span>
                <h3 className="text-base font-bold text-gray-900 mb-2 leading-tight">{step.name}</h3>
                <p className="text-xs text-gray-600 leading-relaxed">{step.desc}</p>
              </div>
              <div className="mt-6 pt-3 border-t border-gray-200 text-xs font-semibold text-blue-700">
                Step {i + 1} of 5
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-12 bg-slate-900 text-white rounded-2xl p-8 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl font-bold mb-1">Ready to start with Step 01?</h3>
            <p className="text-slate-400 text-sm">Schedule your free 45-minute Automation & Cloud Audit today.</p>
          </div>
          <a
            href="#contact"
            className="bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm px-6 py-3 rounded-xl transition-colors shrink-0"
          >
            Book Free Audit
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;
